import React, { useMemo } from "react";
import {
  CONTENT_CATEGORY_TYPE,
  CONTENT_SECTOR_TYPE,
  CONTENT_STORE_TYPE,
  ContentCategoryType,
  ContentStoreType,
  ContentType,
  MainSectionType,
  WebStoreSelectorType,
} from "../../../controller/MasterController";
import { contentName } from "../../../utils/util";
import CategoryContent from "../content/categoryContent";
import StoreContent from "../content/storeContent";
import { ThemeType } from "../../../recoil/theme";

interface StoreListProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  currentDate: Date;
  navigateSector: any;
  theme: ThemeType;
}

const StoreContents = ({
  storeList,
  lang,
  currentDate,
  navigateSector,
  theme,
}: StoreListProps) => {
  const StoreContents = useMemo(() => {
    return (
      <>
        {storeList &&
          storeList.main_section.map((main: MainSectionType, index: number) => {
            return (
              <div key={index} className="centerWrap">
                <div className="deliveryTitle">
                  <div className="row">
                    <h2>{contentName("배달맛집", lang)}</h2>
                    {theme.store_list && (
                      <img src={theme.store_list} alt="sock" />
                    )}
                  </div>
                </div>
                <div className="normalStoreWrap">
                  {main.content.map((group: ContentType, index: number) =>
                    group.content_type === CONTENT_SECTOR_TYPE ? (
                      group.data.store_list.map((store, storeIndex) => (
                        <StoreContent
                          key={storeIndex}
                          item={{
                            content_type: CONTENT_STORE_TYPE,
                            data: store,
                          }}
                          currentDate={currentDate}
                          navigateSector={navigateSector}
                          type={"main"}
                        />
                      ))
                    ) : group.content_type === CONTENT_STORE_TYPE ? (
                      <StoreContent
                        key={index}
                        item={group as ContentStoreType}
                        currentDate={currentDate}
                        navigateSector={navigateSector}
                        type={"main"}
                      />
                    ) : (
                      group.content_type === CONTENT_CATEGORY_TYPE && (
                        <CategoryContent
                          key={index}
                          item={group as ContentCategoryType}
                          navigateSector={navigateSector}
                        />
                      )
                    )
                  )}
                </div>
              </div>
            );
          })}
      </>
    );
  }, [storeList, lang, currentDate]);

  return StoreContents;
};
export default StoreContents;
